import { useCombobox } from 'downshift';

const classifyComboboxType = type => {
  const isKeyboard = type === useCombobox.stateChangeTypes.InputKeyDownEnter;
  const isClick = type === useCombobox.stateChangeTypes.ItemClick;
  const isManual = isKeyboard || isClick;
  return {
    isClick,
    isKeyboard,
    isManual
  };
};

const useCustomCombobox = ({
  centres,
  filteredCentres,
  filterCentres,
  onCentreSelected,
  autoSelectOnExactInputMatch,
  itemToString
}) => {
  const inputMatchesItem = (inputValue, selectedItem) => inputValue === undefined ? false : inputValue.toLowerCase() === itemToString(selectedItem).toLowerCase();

  return useCombobox({
    items: filteredCentres,

    onInputValueChange(changes) {
      filterCentres(changes);
      const exactMatch = centres.find(centre => inputMatchesItem(changes.inputValue, centre));

      if (autoSelectOnExactInputMatch && exactMatch) {
        onCentreSelected === null || onCentreSelected === void 0 ? void 0 : onCentreSelected(exactMatch, true);
      }
    },

    inputId: 'centreSearch',
    itemToString,

    onSelectedItemChange({
      selectedItem,
      type
    }) {
      const {
        isKeyboard
      } = classifyComboboxType(type);

      if (selectedItem) {
        onCentreSelected === null || onCentreSelected === void 0 ? void 0 : onCentreSelected(selectedItem, isKeyboard);
      }
    },

    stateReducer(state, actionAndChanges) {
      const {
        type,
        changes
      } = actionAndChanges; // When selecting the "No results" item, we don't want the state to change
      // (ie; we act like the selection never happened)

      const {
        isManual
      } = classifyComboboxType(type);

      if (isManual && !filteredCentres.length) {
        return state;
      } else {
        return changes;
      }
    }

  });
};

export default useCustomCombobox;